import React, { useState } from "react";

function ServiceManagement() {
  const [services, setServices] = useState([
    { id: 1, name: "Boundary Survey", description: "Survey to establish property lines" },
    { id: 2, name: "Topographic Survey", description: "Survey to map land features" },
  ]);

  const [newService, setNewService] = useState({ name: "", description: "" });
  const [editingService, setEditingService] = useState(null);

  const handleAddService = () => {
    if (!newService.name || !newService.description) return;
    setServices([
      ...services,
      { id: Date.now(), name: newService.name, description: newService.description },
    ]);
    setNewService({ name: "", description: "" });
  };

  const handleEditService = (id) => {
    const updatedServices = services.map((service) =>
      service.id === id ? editingService : service
    );
    setServices(updatedServices);
    setEditingService(null);
  };

  const handleDeleteService = (id) => {
    setServices(services.filter((service) => service.id !== id));
  };

  return (
    <div className="max-w-2xl p-6 mx-auto rounded-lg shadow-md bg-gray-50">
      <h2 className="mb-6 text-2xl font-bold text-center text-blue-600">Service Management</h2>

      {/* Add Service Form */}
      <div className="mb-6">
        <h3 className="mb-2 text-lg font-semibold">Add New Service</h3>
        <div className="flex flex-col gap-2">
          <input
            type="text"
            placeholder="Service Name"
            value={newService.name}
            onChange={(e) => setNewService({ ...newService, name: e.target.value })}
            className="px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <input
            type="text"
            placeholder="Description"
            value={newService.description}
            onChange={(e) => setNewService({ ...newService, description: e.target.value })}
            className="px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <button
            onClick={handleAddService}
            className="px-4 py-2 text-white transition bg-blue-600 rounded hover:bg-blue-700"
          >
            Add Service
          </button>
        </div>
      </div>

      {/* Service List */}
      <h3 className="mb-3 text-lg font-semibold">Existing Services</h3>
      <ul className="space-y-4">
        {services.map((service) => (
          <li
            key={service.id}
            className="flex items-center justify-between p-4 bg-white rounded shadow"
          >
            {editingService && editingService.id === service.id ? (
              <div className="flex flex-col w-full gap-2">
                <input
                  type="text"
                  value={editingService.name}
                  onChange={(e) =>
                    setEditingService({ ...editingService, name: e.target.value })
                  }
                  className="px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-green-400"
                />
                <input
                  type="text"
                  value={editingService.description}
                  onChange={(e) =>
                    setEditingService({ ...editingService, description: e.target.value })
                  }
                  className="px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-green-400"
                />
                <div className="flex gap-2">
                  <button
                    onClick={() => handleEditService(service.id)}
                    className="px-3 py-1 text-white bg-green-600 rounded hover:bg-green-700"
                  >
                    Save
                  </button>
                  <button
                    onClick={() => setEditingService(null)}
                    className="px-3 py-1 text-white bg-gray-400 rounded hover:bg-gray-500"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-between w-full">
                <div>
                  <p className="font-bold text-gray-800">{service.name}</p>
                  <p className="text-gray-600">{service.description}</p>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => setEditingService(service)}
                    className="px-3 py-1 text-white bg-yellow-500 rounded hover:bg-yellow-600"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDeleteService(service.id)}
                    className="px-3 py-1 text-white bg-red-600 rounded hover:bg-red-700"
                  >
                    Delete
                  </button>
                </div>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ServiceManagement;
